import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { Store } from '@ngxs/store';
import { take } from 'rxjs/operators';
import { LoginByToken } from '../../store/app.actions';

@Component({
  selector: 'app-login-by-cliahealth',
  imports: [],
  templateUrl: './login-by-cliahealth.component.html',
  styleUrl: './login-by-cliahealth.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoginByCliahealthComponent implements OnInit {
  constructor(
    private route: ActivatedRoute,
    private store: Store,
  ) {}

  ngOnInit(): void {
    this.route.queryParams.pipe(take(1)).subscribe((params: Params): void => {
      if (params?.token) {
        this.store.dispatch(new LoginByToken(params.token, true));
      }
    });
  }
}
